
import { IChuongTrinhDaoTaoChiTietActionTypes } from "../../action-types/chuong-trinh-dao-tao/IChuongTrinhDaoTaoChiTietActions";
import { IChuongTrinhDaoTaoChiTietReducer } from "../../reducer-model/chuong-trinh-dao-tao/IChuongTrinhDaoTaoChiTietReducer";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
const iniState: IChuongTrinhDaoTaoChiTietReducer = {
    chuongTrinhDaoTaos: []
};
export const chuongTrinhDaoTaoChiTietReducer = (
    state: IChuongTrinhDaoTaoChiTietReducer = iniState,
    action: IChuongTrinhDaoTaoChiTietActionTypes
): IChuongTrinhDaoTaoChiTietReducer => {
    switch (action.type) {
        case "CHUONG_TRINH_DAO_TAO_CHI_TIET_INI_START":
            return {
                ...state,
                chuongTrinhDaoTaos: {
                    ...state.chuongTrinhDaoTaos, [action.payload]: {
                        id_dt: action.payload,
                        chuongTrinhDaoTaoChiTiets: [],
                        chuongTrinhDaoTaoRangBuocs: [],
                        status: eReducerStatusBase.is_not_initialization,
                        chuongTrinhDaoTaoNhomTuChons: [],
                        focusedTab: "mon-hoc"
                    }
                }
            };
        case "CHUONG_TRINH_DAO_TAO_CHI_TIET_LOAD_BY_CTDT_START":
            return {
                ...state,
                chuongTrinhDaoTaos: {
                    ...state.chuongTrinhDaoTaos,
                    [action.payload]: {
                        ...state.chuongTrinhDaoTaos[action.payload],
                        status: eReducerStatusBase.is_loading
                    }

                }
            };
        case "CHUONG_TRINH_DAO_TAO_CHI_TIET_LOAD_BY_CTDT_SUCCESS":
            return {
                ...state,
                chuongTrinhDaoTaos: {
                    ...state.chuongTrinhDaoTaos,
                    [action.payload.id_dt]: {
                        ...state.chuongTrinhDaoTaos[action.payload.id_dt],
                        status: eReducerStatusBase.is_completed,
                        chuongTrinhDaoTaoChiTiets: action.payload.data.chuongTrinhDaoTaoChiTiets,
                        chuongTrinhDaoTaoRangBuocs: action.payload.data.chuongTrinhDaoTaoRangBuocs,
                        chuongTrinhDaoTaoNhomTuChons: action.payload.data.chuongTrinhDaoTaoNhomTuChons,
                    }
                }

            };
        case "CHUONG_TRINH_DAO_TAO_CHI_TIET_LOAD_BY_CTDT_ERROR":
            return {
                ...state,
                chuongTrinhDaoTaos: {
                    ...state.chuongTrinhDaoTaos,
                    [action.payload.id_dt]: {
                        ...state.chuongTrinhDaoTaos[action.payload.id_dt],
                        status: eReducerStatusBase.is_completed,
                    }
                }

            };
        case "CHUONG_TRINH_DAO_TAO_CHI_TIET_CHANGE_FOCUSED_TAB":
            return {
                ...state,
                chuongTrinhDaoTaos: {
                    ...state.chuongTrinhDaoTaos,
                    [action.payload.id_dt]: {
                        ...state.chuongTrinhDaoTaos[action.payload.id_dt],
                        focusedTab: action.payload.data
                    }
                }

            };
        case "CHUONG_TRINH_DAO_TAO_CHI_TIET_UPDATE_CONG_THUC_START":
            return {
                ...state,
                chuongTrinhDaoTaos: {
                    ...state.chuongTrinhDaoTaos,
                    [action.payload.id_dt]: {
                        ...state.chuongTrinhDaoTaos[action.payload.id_dt],
                        status: eReducerStatusBase.is_loading
                    }
                }
            };
        case "CHUONG_TRINH_DAO_TAO_CHI_TIET_UPDATE_CONG_THUC_SUCCESS":
            return {
                ...state,
                chuongTrinhDaoTaos: {
                    ...state.chuongTrinhDaoTaos,
                    [action.payload.id_dt]: {
                        ...state.chuongTrinhDaoTaos[action.payload.id_dt],
                        status: eReducerStatusBase.is_need_reload,
                    }
                }
            };
        case "CHUONG_TRINH_DAO_TAO_CHI_TIET_UPDATE_CONG_THUC_ERROR":
            return {
                ...state,
                chuongTrinhDaoTaos: {
                    ...state.chuongTrinhDaoTaos,
                    [action.payload.id_dt]: {
                        ...state.chuongTrinhDaoTaos[action.payload.id_dt],
                        status: eReducerStatusBase.is_completed,
                    }
                }
            };
        case "CHUONG_TRINH_DAO_TAO_CHI_TIET_UPLOAD_CONG_THUC_MODAL_OPEN":
            return {
                ...state,
                chuongTrinhDaoTaos: {
                    ...state.chuongTrinhDaoTaos,
                    [action.payload.id_dt]: {
                        ...state.chuongTrinhDaoTaos[action.payload.id_dt],
                        isShowUploadCongThucModal: true
                    }
                }
            };
        case "CHUONG_TRINH_DAO_TAO_CHI_TIET_UPLOAD_CONG_THUC_MODAL_CLOSE":
            return {
                ...state,
                chuongTrinhDaoTaos: {
                    ...state.chuongTrinhDaoTaos,
                    [action.payload.id_dt]: {
                        ...state.chuongTrinhDaoTaos[action.payload.id_dt],
                            isShowUploadCongThucModal: false
                        }
                    }
            };
        default:
            return state;
    }
};
